<template lang="pug">
  .page
    section
      b-container
        h1 Message Received
        h4 Your contact form has been submitted
        p A member of our team will get back to you as soon as possible. In the meantime, feel free to browse our FAQ section for answers to common questions.

</template>

<script>

export default {
  name: 'ContactOk',
  components: {
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/ContactOk.vue